import React from "react";
import styles from "./Button.module.scss";

type ButtonVariant = "cancel" | "next" | "custom";

interface ButtonProps {
    label: string;
    variant?: ButtonVariant;
    redirectTo?: string;
    onClick?: () => void;
    disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
                                                  label,
                                                  variant = "custom",
                                                  redirectTo,
                                                  onClick,
                                                  disabled = false,
                                              }) => {
    const handleClick = () => {
        if (disabled) return;
        if (redirectTo) {
            window.location.href = redirectTo;
        } else if (onClick) {
            onClick();
        }
    };

    return (
        <button
            className={`${styles.button} ${styles[variant]} ${disabled ? styles.disabled : ""}`}
            onClick={handleClick}
            disabled={disabled}
        >
            {label}
        </button>
    );
};